import { render, staticRenderFns } from "./refund-address-info.vue?vue&type=template&id=73f8642c&scoped=true"
import script from "./refund-address-info.vue?vue&type=script&lang=ts"
export * from "./refund-address-info.vue?vue&type=script&lang=ts"
import style0 from "./refund-address-info.vue?vue&type=style&index=0&id=73f8642c&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73f8642c",
  null
  
)

export default component.exports